// extracted by mini-css-extract-plugin
export default {"main":"aboutUs_main__IpNZZ","mission":"aboutUs_mission__PhnTk","vision":"aboutUs_vision__3+9Mm","overview":"aboutUs_overview__iyQTd"};